import {MainSidebarButton} from 'apstra-ui-common';
import cx from 'classnames';
import React, {useEffect, useState} from 'react';
import {Container, Header, Icon, Loader, Modal, ModalContent} from 'semantic-ui-react';

import './FeedbackButton.less';

const checkIsOnline = async (): Promise<boolean> => {
  try {
    await fetch('https://forms.office.com', {method: 'HEAD', mode: 'no-cors'});
    return true;
  } catch {
    return false;
  }
};

interface FeedbackButtonProps {
  iframeLink?: string;
  mailToLink?: string;
}

export const FeedbackButton: React.FC<FeedbackButtonProps> = ({
  iframeLink = 'https://forms.office.com/pages/responsepage.aspx?id=' +
    'PIunvttMMEGFSh0ZMjLl9OVai3Wz1iZPtSBUPA7SgyxUOFZGUEdWR1hCVlBMU1BEVzBMVVpTR1ZKSi4u&route=shorturl',
  mailToLink = 'mailto:apstra-feedback@juniper.net?subject=Apstra Product Feedback',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOnline, setIsOnline] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    if (isOpen) {
      setIsOnline(null);
      setIsLoading(true);
      checkIsOnline().then(setIsOnline);
    }
  }, [isOpen]);

  return (
    <>
      <MainSidebarButton
        right
        aria-label='feedback'
        icon='comments outline'
        menuKey='feedback'
        onClick={() => setIsOpen(true)}
        order={100}
      />
      <Modal
        className='feedback-modal'
        closeIcon
        closeOnDimmerClick={false}
        onClose={() => setIsOpen(false)}
        open={isOpen}
        size='large'
      >
        <Header icon='comments outline' content='Give Feedback' />
        <ModalContent>
          {(isLoading && isOnline !== false) && <Loader active />}
          {isOnline === false &&
            <Container textAlign='center'>
              <p>{'Failed to load feedback form.'}</p>
              <a href={mailToLink}><Icon name='mail' />{' Send feedback via email'}</a>
            </Container>
          }
          <iframe
            className={cx('feedback-frame', {visible: isOnline && !isLoading})}
            src={iframeLink}
            title='Feedback Form'
            onLoad={() => {
              setIsLoading(false);
            }}
          />
        </ModalContent>
      </Modal>
    </>
  );
};

export default FeedbackButton;
